// Consultation description fallback (INH-4988).
//
// The shelf description is optional: no FE gate blocks an empty textarea.
// The BE still registers the consultation lead from the description it
// receives, so every submission path — process-card-payment charges and
// store-referral-lead — must send a non-empty string. An empty or
// whitespace-only draft falls back to this sentinel instead of blocking
// the user or omitting the field.
export const CONSULTATION_NO_DETAILS_FALLBACK = "User provided no details";

export const resolveConsultationDescription = (text?: string | null): string =>
  text?.trim() || CONSULTATION_NO_DETAILS_FALLBACK;
